async function fetchGraphQL(query, variables = {}) {
  try {
    const response = await fetch(
      "https://6eaf6d-c7.myshopify.com/api/2023-04/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "03abae6300fb519f9df50a669079e8fd",
        },
        body: JSON.stringify({ query, variables }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const jsonResponse = await response.json();
    if (jsonResponse.errors) {
      console.error("GraphQL errors:", jsonResponse.errors);
    }

    return jsonResponse.data;
  } catch (error) {
    console.error("Fetch GraphQL error:", error);
    throw error;
  }
}

async function addToCart(variantId, quantity = 1) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error("Add to cart error:", error);
    throw error;
  }
}

async function fetchCart() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error("Fetch cart error:", error);
    throw error;
  }
}
